import React from "react";
import { StyleSheet, View, Pressable, TouchableOpacity } from "react-native";

//Custom Imports
import Edit from "@assets/svg/Edit";
import color from "@constants/color";
import Text from "@components/CustomText";
import VacationIcon from "@assets/svg/Vacation/VacationIcon";

const UpcomingLeaveModal = ({
  setMainModalVisible = () => {},
  upcomingData = {},
  onEditPress = () => {},
}) => {
  const { description, title, buttons } = upcomingData;

  return (
    <View style={styles.container}>
      <VacationIcon width={110} height={80} />
      <Text
        style={{ marginTop: 20, color: color.mediumBlack }}
        variant="title_18_semi"
        newfont={true}
      >
        {title}
      </Text>
      <Text style={styles.description} variant="body_text_3" newfont={true}>
        {description}
      </Text>
      <TouchableOpacity
        onPress={onEditPress}
        style={{
          flexDirection: "row",
          backgroundColor: "rgba(0, 0, 0, 0.1)",
          paddingHorizontal: 20,
          paddingTop: 9,
          borderRadius: 5,
          marginTop: 16,
          alignItems: "center",
          paddingBottom: 7,
        }}
      >
        <Edit width="15" height="15 " />
        <Text
          style={{
            marginLeft: 10,
            color: color.mediumBlack,
          }}
          variant="subtitle_16"
          newfont={true}
        >
          {Array.isArray(buttons) && buttons[0].text ? buttons[0].text : ""}
        </Text>
      </TouchableOpacity>
      <Pressable style={{ paddingTop: 20 }} onPress={setMainModalVisible}>
        <Text
          style={{
            color: color.primary,
          }}
          variant="subtitle_16"
          newfont={true}
        >
          {Array.isArray(buttons) && buttons[1].text ? buttons[1].text : ""}
        </Text>
      </Pressable>
    </View>
  );
};

export default UpcomingLeaveModal;

const styles = StyleSheet.create({
  container: {
    backgroundColor: color.white,
    paddingTop: 40,
    width: "90%",
    borderRadius: 6,
    alignItems: "center",
    justifyContent: "center",
    paddingBottom: 24,
  },
  description: {
    marginTop: 4,
    color: color.lightBlack,
    width: "70%",
    textAlign: "center",
    alignSelf: "center",
  },
});
